import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const slides = [{
  src: 'https://cdn.magicpatterns.com/uploads/heNmeRVBTcwG2Px3k87uMS/introduccion.png',
  label: 'Introducción · Por qué algunas personas te desgastan tanto'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/sPmGduUKgiAGjMiocP2FgS/modulo_1.png',
  label: 'Módulo 1 · ¿Por qué algunas personas te desgastan tanto?'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/d6w8VVH8kpXaVWRhZuX6pv/modulo_1_(2).png',
  label: 'Módulo 1 · Entender a la gente complicada'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/vSdgDspqZ9xdh9urDZTdPM/modulo_1_(9).png',
  label: 'Módulo 1 · El error de justificar comportamientos tóxicos'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/cBdTVw7YsTS5xp818DHJCL/modulo_5_(9).png',
  label: 'Módulo 5 · El poder de tomar distancia emocional'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/hHTXEiKgagjcBTZvAi9crC/modulo_6_(2).png',
  label: 'Módulo 6 · Cuando un compañero critica todo'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/nGkRqeGNiShmNdGSrqyweS/BONUS_PREMIUM_-_PERSONALIDADES_(1).png',
  label: 'Bonus Premium · Personalidades difíciles explicadas'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/qDtRxzn9KHYuPY2CkEAddw/BONUS_PREMIUM_-_PERSONALIDADES_(10).png',
  label: 'Bonus Premium · El que critica todo'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/41prAFDwxnaMq82H5NSNVX/BONUS_PREMIUM_-_PERSONALIDADES_(21).png',
  label: 'Bonus Premium · Tu energía mental importa'
}];
export function PreviewSection() {
  const [index, setIndex] = useState(0);
  const [dir, setDir] = useState(0);
  const go = (d: number) => {
    setDir(d);
    setIndex(p => (p + d + slides.length) % slides.length);
  };
  return <section className="w-full py-20 md:py-28 px-4" data-id="element-293">
      <div className="max-w-5xl mx-auto" data-id="element-294">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-295">
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-296">
            👀 Mirá{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-297">
              por dentro
            </span>
          </h2>
          <p className="font-serif-italic text-rose text-lg md:text-xl mt-3" data-id="element-298">
            Páginas reales del material que vas a recibir
          </p>
        </motion.div>

        <div className="relative" data-id="element-299">
          <div className="relative bg-white border border-line rounded-3xl p-3 md:p-5 shadow-xl" data-id="element-300">
            <div className="relative aspect-[3/4] md:aspect-[4/3] rounded-2xl overflow-hidden bg-bg-warm" data-id="element-301">
              <AnimatePresence initial={false} mode="wait" data-id="element-302">
                <motion.img key={index} src={slides[index].src} alt={slides[index].label} initial={{
                opacity: 0,
                x: dir > 0 ? 50 : -50
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: dir > 0 ? -50 : 50
              }} transition={{
                duration: 0.4
              }} className="absolute inset-0 w-full h-full object-contain" data-id="element-303" />
              </AnimatePresence>
            </div>
          </div>

          <button onClick={() => go(-1)} aria-label="Anterior" className="absolute left-1 md:-left-5 top-1/2 -translate-y-1/2 w-11 h-11 md:w-12 md:h-12 rounded-full bg-white border border-line shadow-lg flex items-center justify-center hover:bg-rose hover:text-white text-ink transition-colors" data-id="element-304">
            <ChevronLeftIcon className="w-5 h-5" data-id="element-305" />
          </button>
          <button onClick={() => go(1)} aria-label="Siguiente" className="absolute right-1 md:-right-5 top-1/2 -translate-y-1/2 w-11 h-11 md:w-12 md:h-12 rounded-full bg-white border border-line shadow-lg flex items-center justify-center hover:bg-rose hover:text-white text-ink transition-colors" data-id="element-306">
            <ChevronRightIcon className="w-5 h-5" data-id="element-307" />
          </button>
        </div>

        <div className="flex flex-col items-center gap-4 mt-6" data-id="element-308">
          <div className="text-sm text-muted font-medium text-center px-4 font-serif-italic" data-id="element-309">
            {slides[index].label}
          </div>
          <div className="flex gap-2" data-id="element-310">
            {slides.map((_, i) => <button key={i} aria-label={`Slide ${i + 1}`} onClick={() => {
            setDir(i > index ? 1 : -1);
            setIndex(i);
          }} className={`h-1.5 rounded-full transition-all ${i === index ? 'w-8 bg-rose' : 'w-1.5 bg-rose/25'}`} data-id="element-311" />)}
          </div>
        </div>

        <p className="text-center font-serif-italic text-rose mt-8 text-lg" data-id="element-312">
          La mirada práctica del Método Aula Mater
        </p>
      </div>
    </section>;
}